import { render, staticRenderFns } from "./SampleTableColumn.vue?vue&type=template&id=07094a7e&scoped=true&"
import script from "./SampleTableColumn.vue?vue&type=script&lang=js&"
export * from "./SampleTableColumn.vue?vue&type=script&lang=js&"
import style0 from "./SampleTableColumn.vue?vue&type=style&index=0&id=07094a7e&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07094a7e",
  null
  
)

export default component.exports